// Phase 44.06 — Banner reminder quando il saldo del pack è basso (≤ 2 corse).
// Premium, non aggressivo, posizionato nelle pagine dove le corse pack hanno
// senso (dashboard customer, /app/subscription).
import { useEffect, useState } from "react";
import { AlertTriangle, Sparkles } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function PackLowBalanceBanner({ totalRemaining, onBuyPack, dismissible = true }) {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (typeof totalRemaining === "number" && totalRemaining > 0 && totalRemaining <= 2) {
      trackEvent("pack_balance_low", { remaining: totalRemaining });
    }
  }, [totalRemaining]);

  if (typeof totalRemaining !== "number" || totalRemaining < 1 || totalRemaining > 2 || dismissed) return null;

  return (
    <section
      className="rounded-2xl border-2 border-amber-300 bg-amber-50/70 p-4 flex items-start gap-3"
      data-testid="pack-low-balance-banner"
    >
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-amber-100 text-amber-700 ring-1 ring-amber-200 shrink-0">
        <AlertTriangle className="h-5 w-5" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="font-display text-base font-bold tracking-tight text-amber-900">
          Ti {totalRemaining === 1 ? "resta" : "restano"} {totalRemaining} {totalRemaining === 1 ? "corsa" : "corse"} bonus
        </p>
        <p className="text-xs text-amber-800 mt-0.5 leading-snug">
          Acquista un nuovo pacchetto +10 per continuare a coprire le consegne automaticamente.
        </p>
        <div className="mt-2.5 flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={onBuyPack}
            data-testid="pack-low-buy-btn"
            className="inline-flex items-center gap-1.5 rounded-xl bg-amber-600 text-white px-3 h-9 text-xs font-bold hover:bg-amber-700 transition active:scale-[0.98]"
          >
            <Sparkles className="h-3.5 w-3.5" /> Acquista altre 10 corse
          </button>
          {dismissible && (
            <button
              type="button"
              onClick={() => setDismissed(true)}
              data-testid="pack-low-dismiss-btn"
              className="text-xs font-semibold text-amber-700 hover:text-amber-900 transition"
            >
              Più tardi
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
